// GAVION product-training: the fixed questions of the « Produit » course. Texts: gavion.training.product.q.* (i18n
// modules trainingProduct.*.ts), transcribed from docs/superpowers/specs/2026-11-02-product-training-questions.md.
// Option « a » is the right answer in the texts; `order` is the display order (a permutation of "abcd") so the right
// answer moves around. The § of the Contexte Gavion each question comes from is noted beside it.
import type { ProductMissionKey } from "../../../domain/training/missions";
import type { QuizQuestion } from "../types";

const Q = "gavion.training.product.q";

const quiz = (
  mission: ProductMissionKey,
  id: string,
  order: string,
): QuizQuestion => ({
  id: `${mission}.${id}`,
  promptKey: `${Q}.${mission}.${id}.prompt`,
  options: [...order].map((o) => ({
    id: o,
    labelKey: `${Q}.${mission}.${id}.${o}`,
  })),
  answer: "a",
  explanationKey: `${Q}.${mission}.${id}.explanation`,
});

const AV = "gavion.training.product.availability";
const availability = (
  id: string,
  answer: "available" | "soon",
): QuizQuestion => ({
  id: `product_availability.${id}`,
  promptKey: `${Q}.product_availability.${id}.prompt`,
  options: [
    { id: "available", labelKey: `${AV}.available` },
    { id: "soon", labelKey: `${AV}.soon` },
  ],
  answer,
  explanationKey: `${AV}.explanation`,
});

export const STATIC_QUESTIONS: Record<
  ProductMissionKey,
  readonly QuizQuestion[]
> = {
  product_pitch: [
    quiz("product_pitch", "q1", "bacd"), // §1
    quiz("product_pitch", "q2", "cbad"), // §1, §5
    quiz("product_pitch", "q3", "abdc"), // §1
    quiz("product_pitch", "q4", "bcda"), // §1
    quiz("product_pitch", "q5", "dabc"), // §2, §3
    quiz("product_pitch", "q6", "cdab"), // §1, §9
    quiz("product_pitch", "q7", "abcd"), // §5
    quiz("product_pitch", "q8", "bdca"), // §1
  ],
  product_pricing: [], // built from the catalog (catalogQuestions.ts)
  product_addons: [
    quiz("product_addons", "c1", "badc"), // §3
    quiz("product_addons", "c2", "cabd"), // §3
    quiz("product_addons", "c3", "abcd"), // §3
    quiz("product_addons", "c4", "dbac"), // §3
    quiz("product_addons", "c5", "bcad"), // §3
    quiz("product_addons", "c6", "cdba"), // §3, §11
  ],
  product_fit: [
    quiz("product_fit", "q1", "cabd"), // §3
    quiz("product_fit", "q2", "bdac"), // §3
    quiz("product_fit", "q3", "acbd"), // §2
    quiz("product_fit", "q4", "dcba"), // §3
    quiz("product_fit", "q5", "bacd"), // §3
    quiz("product_fit", "q6", "cdab"), // §3
  ],
  product_objections: [
    quiz("product_objections", "q1", "bacd"), // §9
    quiz("product_objections", "q2", "cbad"), // §1, §9
    quiz("product_objections", "q3", "abdc"), // §9
    quiz("product_objections", "q4", "dbca"), // §6, §9
    quiz("product_objections", "q5", "bacd"), // §6, §9
    quiz("product_objections", "q6", "cdba"), // §8, §9
    quiz("product_objections", "q7", "adbc"), // §6, §9
    quiz("product_objections", "q8", "bdac"), // §9, §10
  ],
  product_availability: [
    availability("q1", "available"), // §2
    availability("q2", "soon"), // §2
    availability("q3", "soon"), // §2
    availability("q4", "available"), // §2
    availability("q5", "soon"), // §2
    availability("q6", "available"), // §2
    availability("q7", "available"), // §2
    availability("q8", "available"), // §2
  ],
  product_how_gala: [
    quiz("product_how_gala", "q1", "bcad"), // §2
    quiz("product_how_gala", "q2", "adcb"), // §2, §7
    quiz("product_how_gala", "q3", "cabd"), // §2, §6
    quiz("product_how_gala", "q4", "abdc"), // §2
    quiz("product_how_gala", "q5", "dabc"), // §2
    quiz("product_how_gala", "q6", "bacd"), // §2
  ],
  product_setup: [
    quiz("product_setup", "q1", "bacd"), // §6
    quiz("product_setup", "q2", "cdab"), // §6
    quiz("product_setup", "q3", "abdc"), // §6
    quiz("product_setup", "q4", "dbac"), // §6
    quiz("product_setup", "q5", "bcad"), // §6
    quiz("product_setup", "q6", "cadb"), // §6
  ],
  product_integrations: [
    quiz("product_integrations", "q1", "abcd"), // §4
    quiz("product_integrations", "q2", "cabd"), // §4, §6
    quiz("product_integrations", "q3", "dbac"), // §4
    quiz("product_integrations", "q4", "bcad"), // §2, §4
    quiz("product_integrations", "q5", "acbd"), // §4
    quiz("product_integrations", "q6", "dacb"), // §10
  ],
  product_client_gets: [
    quiz("product_client_gets", "q1", "bacd"), // §2
    quiz("product_client_gets", "q2", "cabd"), // §2
    quiz("product_client_gets", "q3", "abdc"), // §2
    quiz("product_client_gets", "q4", "dbac"), // §2
    quiz("product_client_gets", "q5", "bcad"), // §5
    quiz("product_client_gets", "q6", "acdb"), // §2
  ],
  product_admin_assistant: [
    quiz("product_admin_assistant", "q1", "abdc"), // §1, §3
    quiz("product_admin_assistant", "q2", "cbad"), // §2
    quiz("product_admin_assistant", "q3", "bdac"), // §3
    quiz("product_admin_assistant", "q4", "dacb"), // §2
    quiz("product_admin_assistant", "q5", "bacd"), // §2
    quiz("product_admin_assistant", "q6", "cabd"), // §2
  ],
};
